import { render, staticRenderFns } from "./AuthorityManagement.vue?vue&type=template&id=b9bcbd46&scoped=true&"
import script from "./AuthorityManagement.vue?vue&type=script&lang=js&"
export * from "./AuthorityManagement.vue?vue&type=script&lang=js&"
import style0 from "./AuthorityManagement.vue?vue&type=style&index=0&id=b9bcbd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bcbd46",
  null
  
)

export default component.exports